import Amplitude from 'amplitude-js';

import { isInCypress } from 'lib/utils/dom';

// NOTE: front-end and amplitude events are treated as lossy, so these functions
// are async to ensure they don't affect the flow. Adblockers are also known to block Amplitude.
export default class EventsClient {
  public static async logAmplitude(name: string, metadata?: { [key: string]: any }) {
    if (import.meta.env.PROD && !isInCypress()) {
      Amplitude.getInstance().logEvent(name, metadata);
    }

    if (import.meta.env.DEV) {
      /* eslint-disable no-console */
      console.groupCollapsed(`%c [Amplitude] ${name}`, 'color: #2a76df');
      if (metadata != null) {
        console.table(metadata);
      }
      console.groupEnd();
      /* eslint-enable no-console */
    }
  }

  public static async logPendo(name: string, metadata?: { [key: string]: any }) {
    if (import.meta.env.PROD && !isInCypress()) {
      window.pendo.track(name, metadata);
    }
  }

  public static async logAll(name: string, metadata?: { [key: string]: any }) {
    EventsClient.logAmplitude(name, metadata);
    EventsClient.logPendo(name, metadata);
  }
}

export enum GraphEvent {
  GraphCanvasZoomIn = 'graph_canvas.zoom_in',
  GraphCanvasZoomOut = 'graph_canvas.zoom_out',
  GraphCanvasDragReposition = 'graph_canvas.drag_reposition',
  GraphCanvasClick = 'graph_canvas.click',
  GraphCanvasRightClick = 'graph_canvas.right_click',
  GraphCanvasNodeHover = 'graph_canvas.node.hover',
  GraphCanvasNodeShowTooltip = 'graph_canvas.node.show_tooltip',
  GraphCanvasNodeClick = 'graph_canvas.node.click',
  GraphCanvasNodeRightClick = 'graph_canvas.node.right_click',
  GraphCanvasNodeDragReposition = 'graph_canvas.node.drag_reposition',
  GraphCanvasEdgeClick = 'graph_canvas.edge.click',
  GraphCanvasEdgeRightClick = 'graph_canvas.edge.right_click',
  GraphCanvasEdgeHover = 'graph_canvas.edge.hover',
  GraphCanvasNodeSelect = 'graph_canvas.node.select',
  GraphExport = 'graph.export.click',
  GraphExportDownload = 'graph.export_download.click',
}
